import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logout } from './../../Actions/Users';
import { setCookie } from '../../Helpers';
import Loader from './../../Layout/Loader';
import withRoutes from '../../HOC/HocRoutes';
import { apiFetch } from '../../Utils/apiFetch';

class LogoutPage extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: true };
  }

  componentDidMount() {
    apiFetch('/api/session', {
      method: 'DELETE',
    })
      .then((res) => res.json())
      .then((response) => {
        this.handleLogoutCleanup();
      })
      .catch((e) => {
        this.handleLogoutCleanup();
      });
  }

  handleLogoutCleanup = () => {
    localStorage.removeItem('privileges');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('adminToken');
    setCookie('JSESSIONID', 0);
    this.props.dispatch(logout());
    this.setState({ loading: false });
    this.props.navigate('/login');
  };

  render() {
    return this.state.loading ? <Loader /> : null;
  }
}

const mapStateToProps = () => ({});
export const LogOut = connect(mapStateToProps)(withRoutes(LogoutPage));
